export class PaginationOption {
    public display: string;
    public value: number;
    public disabled: boolean;
}


// WEBPACK FOOTER //
// C:/WORK/Projects/ActNow_NG2/src/models/common/pagination-option.ts